import {z} from 'zod';
import {defaultBidderGroup, IBidderGroup} from './BidderGroup';

export type BidderGroupFormValues = {
    id: number | null;
    name: string;
    bidderIds: number[];
    ivtSensitive: boolean;
};

export const bidderGroupFormSchema = z.object({
    id: z.number().nullable(),
    name: z.string().trim().min(1, 'Name is required'),
    bidderIds: z.array(z.number()).nullable(),
    ivtSensitive: z.boolean(),
});

export const normalizeBidderIds = (ids?: Array<number | {id?: number; value?: number}>) => (ids ?? [])
    .map(id => {
        if (typeof id === 'number') return id;
        if (id && typeof id === 'object') {
            if (typeof id.id === 'number') return id.id;
            if (typeof id.value === 'number') return id.value;
        }
        return null;
    })
    .filter((value): value is number => typeof value === 'number');

export const toBidderGroupFormValues = (group?: IBidderGroup): BidderGroupFormValues => {
    const source = group ?? defaultBidderGroup;
    return {
        id: source.id ?? null,
        name: source.name ?? '',
        bidderIds: normalizeBidderIds(source.bidderIds as any),
        ivtSensitive: source.ivtSensitive ?? false,
    };
};

export const toBidderGroupSubmitValues = (values: BidderGroupFormValues, existingGroup?: IBidderGroup): IBidderGroup => ({
    ...defaultBidderGroup,
    ...existingGroup,
    name: values.name,
    bidderIds: normalizeBidderIds(values.bidderIds as any),
    ivtSensitive: values.ivtSensitive,
});
